import { render, staticRenderFns } from "./test-block.vue?vue&type=template&id=06658220&scoped=true"
import script from "./test-block.vue?vue&type=script&lang=js"
export * from "./test-block.vue?vue&type=script&lang=js"
import style0 from "./test-block.vue?vue&type=style&index=0&id=06658220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06658220",
  null
  
)

export default component.exports